<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Upload Image"
      centered
      hide-footer
      size="lg">

      <b-container fluid>
        <b-row>

          <b-col v-if="processing" cols="12">
            <i class="fas fa-spinner fa-spin"></i>
            Processing...
          </b-col>
          <b-col cols="12" xl="6">
            <template v-if="showCropTool">
              <h4 class="text-center inline">Original</h4>
              <div style="height:400px;">
                <!-- eslint-disable-next-line -->
                <vue-croppie :enableResize="false" :enableExif="true" ref="croppieRef"
                             :enable-orientation="true"
                             :viewport="{ width: viewportWidth, height: viewportHeight }"
                             :boundary="{ width: '100%', height: '100%' }"
                             @result="result"/>
              </div>

            </template>
          </b-col>

          <b-col cols="12" xl="6" class="mt-5 mt-xl-0 text-center">
            <template v-if="showCropTool">
              <h4 class="text-center">Cropped</h4>
              <img :src="cropped" :width="viewportWidth" class="crop-preview" height="auto">
            </template>
          </b-col>

          <b-col cols="12" class="mt-3 mt-xl-5"/>

          <b-col cols="12" lg="6">
            <b-form-group>
              <b-button :disabled="disabled" variant="primary" @click="crop()">
                Crop
              </b-button>
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="6">
            <ol>
              <li>Adjust the cropping viewport and click <code>Crop</code></li>
              <li>Close this window when satisfied with the cropped image</li>
            </ol>
          </b-col>

        </b-row>
      </b-container>

      <b-button
        variant="outline-primary"
        block
        @click="showModal = false">
        Close
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import loadImage from 'blueimp-load-image'
import { mapState } from 'vuex'
import validationErrors from './validation-errors'
import { srcToFile } from '../../../helpers'

export default {
  components: {
    validationErrors
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    cropHeight: {
      type: Number,
      required: true
    },
    cropWidth: {
      type: Number,
      required: true
    },
    fileForEdit: {
      type: File,
      default: function() {
        return new File([], '')
      }
    }
  },
  data () {
    return {
      showModal: false,
      showCropTool: false,
      uploadModalShow: false,
      cropped: null,
      imageName: null,
      viewportWidth: 400,
      defaultZoom: 0,
      showInput: true,
      processing: false
    }
  },
  computed: {
    ...mapState('config', {
      apiConfig: 'data'
    }),
    viewportHeight () {
      return this.cropHeight / this.cropWidth * this.viewportWidth
    }
  },
  watch: {
    showModal: function (newState, oldState) {
      if (newState === false) {
        this.$emit('hidden')
      }
    }
  },
  methods: {
    crop () {
      if (!this.imageName) { return }

      const options = {
        size: { width: this.cropWidth, height: this.cropHeight },
        format: 'png'
      }

      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output
        const name = `${this.imageName.replace(/\.[^/.]+$/, '')}.png`
        srcToFile(this.cropped, name, 'image/png')
          .then((image) => {
            this.$emit('cropped', image)
            this.$emit('cropImage', true)
          })
      })
    },
    reset() {
      this.cropped = null
      this.showCropTool = false
      this.showInput = false
      this.$nextTick(() => { this.showInput = true })
      this.$emit('cropImage', false)
    },
    result (output) {
      this.cropped = output
    },
    openModal () {
      this.showModal = true
      this.changeImage()
    },
    changeImage () {
      this.showCropTool = true
      this.processing = true
      this.$nextTick(() => {
        this.imageName = this.fileForEdit.name

        loadImage.parseMetaData(this.fileForEdit, (data) => {
          let orientation = 0
          if (data.exif) {
            orientation = data.exif.get('Orientation')
          }

          loadImage(
            this.fileForEdit,
            (canvas) => {
              const base64data = canvas.toDataURL()
              this.$refs.croppieRef.bind({
                url: base64data
              }).then(() => {
                this.$refs.croppieRef.setZoom(this.defaultZoom)
                this.processing = false
              })
            },
            {
              canvas: true,
              orientation: orientation
            }
          )
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/form/image-crop.vue